module.exports = __webpack_public_path__ + "static/media/194.89989cc4.webp";